import React, { FC } from 'react';
import { t } from 'i18next';
import { remarkValidator } from '@common/utils';
import { TextArea } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const RemarksField: FC = () => (
  <div className={css.field}>
    <TextArea
      className={css.textArea}
      label={`${t('planner.remarks')} - max 300 char.`}
      name="remarks"
      validate={remarkValidator}
      data-testid="mobility-planner-edit-form-remarks"
    />
  </div>
);

export default RemarksField;
